//
// helpers/is-func.js - check if something is a function
//

export default function is_func(f) {
  return !!(f && f.constructor && f.call && f.apply);
}
